<template>
  <div class="page-content ride-credits">
    <div class="row">
      <div class="col-sm-6 col-12">
        <add-ride-credit />
        <prepaid-card-amount-approval />
      </div>
      <div class="col-sm-6 col-12">
        <auto-reload-ride-credits />
        <redeem-uber-gift />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { nextTick, onMounted, defineAsyncComponent } from 'vue';
import { useRoute } from 'vue-router';

import util from '@/Utils/util';

const RedeemUberGift = defineAsyncComponent(() => import('./RideCredits/RedeemUberGift.vue') as any);

const AddRideCredit = defineAsyncComponent(() => import('./RideCredits/AddRideCredit.vue') as any);

const AutoReloadRideCredits = defineAsyncComponent(() => import('./RideCredits/AutoReloadRideCredits.vue') as any);

const PrepaidCardAmountApproval = defineAsyncComponent(() => import('./RideCredits/PrepaidCardAmountApproval.vue') as any);

onMounted(async () => {
  const route = useRoute();
  const { hash } = route;

  await nextTick();
  util.moveScrollComponent(hash);
});
</script>
